import { motion } from "framer-motion";
import { useContent } from "../context/ContentContext";

export const Manifesto = () => {
  const { content } = useContent();
  const m = content.manifesto || {};
  const chapters = m.chapters || [];
  return (
    <section id="protocol" className="relative py-24 lg:py-36 bg-[#0a0a0a] border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-16 max-w-2xl">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-accent">// The Protocol</span>
          <h2 className="mt-5 font-display font-black uppercase tracking-tighter text-4xl sm:text-6xl leading-[0.9]">
            {m.heading}
          </h2>
          <p className="mt-6 font-body text-white/50 leading-relaxed">
            {m.sub}
          </p>
        </div>

        <div className="border-t border-white/10">
          {chapters.map((c, i) => (
            <motion.div
              key={c.node}
              data-testid={`chapter-${c.node}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              className="group grid grid-cols-12 items-center gap-4 py-7 border-b border-white/10 hover:bg-black/40 transition-colors duration-400 px-2 lg:px-4"
            >
              <div className="col-span-2 lg:col-span-1 font-mono text-sm text-white/30 group-hover:text-accent transition-colors duration-300">
                {c.node}
              </div>
              <div className="col-span-10 lg:col-span-4">
                <h3 className="font-display font-bold text-2xl lg:text-3xl tracking-tight group-hover:translate-x-2 transition-transform duration-400">
                  {c.title}
                </h3>
              </div>
              <div className="col-span-12 lg:col-span-7 lg:pl-8">
                <p className="font-body text-sm lg:text-base text-white/45 leading-relaxed">{c.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <p className="mt-8 font-mono text-xs uppercase tracking-[0.25em] text-white/30">{m.bonus}</p>
      </div>
    </section>
  );
};
